import * as React from "react";
import * as PropTypes from "prop-types";

import { NavStructurePropTypes } from "../../vars";

import OverlayCollapsible from "./OverlayCollapsible";
import { OverlayLink } from "./OverlayCollapsibleLabel";

class OverlayAccordion extends React.Component<any, any> {
  static propTypes = {
    ...NavStructurePropTypes,
    defaultActiveKey: PropTypes.any,
    onItemActivation: PropTypes.func
  };

  items: any;

  constructor(props) {
    super(props);

    this.state = {
      activeKey: props.defaultActiveKey || null
    };

    this.items = {};
  }

  componentDidMount() {
    const { defaultActiveKey, onItemActivation } = this.props;

    if (defaultActiveKey && onItemActivation) {
      this.notifyParent(defaultActiveKey);
    }
  }

  activateItem = key => () => ({ activeKey: key });

  getItem = key => this.items[key];

  handleActivation = (_open, key) => {
    if (this.getActiveKey() === key) {
      key = null;
    }

    this.setState(this.activateItem(key));

    if (this.props.onItemActivation) {
      this.notifyParent(key);
    }
  };

  notifyParent = key => {
    const item = this.getItem(key);

    if (item) {
      this.props.onItemActivation(item);
    }
  };

  getActiveKey = () =>
    this.props.activeKey != null ? this.props.activeKey : this.state.activeKey;

  renderOverlayCollapsible = (navItem, index) => {
    const { label, menuItems } = navItem;

    return (
      <OverlayCollapsible
        key={label.text + index}
        itemKey={index + 1}
        itemRef={elem => (this.items[index + 1] = elem)}
        label={label}
        menuItems={menuItems}
        open={this.getActiveKey() == index + 1}
        onToggle={this.handleActivation}
      />
    );
  };

  render() {
    const { navStructure } = this.props;

    return (
      <div>
        <OverlayLink icon="dashboard" href="/my-account/dashboard">
          Dashboard
        </OverlayLink>
        {navStructure.map(this.renderOverlayCollapsible)}
      </div>
    );
  }
}

export default OverlayAccordion;
